module.exports = __webpack_public_path__ + "assets/img/location.6a73ef03.svg";